import { InlineStatus } from 'components/InlineStatus';
import { usePlace } from 'features/places/hooks/usePlace';
import { MapPinDrawerContent } from 'features/mapping/components/MapPinDrawerContent';

type PlaceDrawerContentProps = {
  placeId: number;
};

export const PlaceDrawerContent = ({
  placeId,
}: PlaceDrawerContentProps): JSX.Element => {
  const { place, loading } = usePlace(placeId);

  if (loading) {
    return <InlineStatus status="loading" />;
  }

  if (!place) {
    return <InlineStatus status="error" />;
  }

  return (
    <MapPinDrawerContent
      lat={place.address.coordinates.latitude}
      lng={place.address.coordinates.longitude}
      place={place}
    />
  );
};
